export default __webpack_public_path__ + "static/media/mhd.67bc64c8.jpg";